export default [{
  title: 'Waterford Web Design',
  description: 'We provide luxury Waterford web design services in the Munster region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'waterford-web-design'
}, {
  title: 'Dublin Web Design',
  description: 'We provide luxury Dublin web design services in the Leinster region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'dublin-web-design'
}, {
  title: 'Cork Web Design',
  description: 'We provide luxury Cork web design services in the Munster region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'cork-web-design'
}, {
  title: 'Web Design Agency',
  description: 'We provide luxury web design services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'web-design-agency'
}, {
  title: 'Web De',
  description: 'We provide luxury web design services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'web-de'
}, {
  title: 'Website',
  description: 'We provide luxury web design services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'website'
}, {
  title: 'Logo Design',
  description: 'We provide luxury logo design services in Ireland and internationally, including web design, search engine optimisation (SEO) and software consultancy.',
  path: 'logo-design'
}, {
  title: 'Graphic Design',
  description: 'We provide luxury graphic design services in Ireland and internationally, including web design, search engine optimisation (SEO) and software consultancy.',
  path: 'graphic-design'
}, {
  title: 'Website Design',
  description: 'We provide luxury website design services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'website-design'
}, {
  title: 'Website Builder',
  description: 'We provide luxury website builder services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'website-builder'
}, {
  title: 'Website Templates',
  description: 'We provide luxury website templates in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'website-templates'
}, {
  title: 'Graphic Designer',
  description: 'We provide luxury graphic designer consultancy in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'graphic-designer'
}, {
  title: 'Web Page',
  description: 'We provide luxury web page services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'web-page'
}, {
  title: 'React',
  description: 'We provide React consultancy services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'react'
}, {
  title: 'Node.js',
  description: 'We provide Node.js consultancy services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'node-js'
}, {
  title: 'Web Agency',
  description: 'We provide web agency services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'web-agency'
}, {
  title: 'Galway Web Design',
  description: 'We provide luxury Galway web design services in the Connacht region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'galway-web-design'
}, {
  title: 'Kerry Web Design',
  description: 'We provide luxury Kerry web design services in the Munster region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'kerry-web-design'
}, {
  title: 'Web Hosting',
  description: 'We provide web hosting services in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'web-hosting'
}, {
  title: 'Web Design Ireland',
  description: 'We provide luxury web design Ireland services both in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'web-design-ireland'
}, {
  title: 'Build website',
  description: 'We can build your website and provide luxury web design Ireland services both in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'build-website'
}, {
  title: 'Professional Website',
  description: 'We can build your professional website and provide luxury web design Ireland services both in Ireland and internationally, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'professional-website'
}, {
  title: 'Waterford Web Agency',
  description: 'We provide luxury Waterford web agency services in the Munster region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'waterford-web-agency'
}, {
  title: 'Tramore Web Design',
  description: 'We provide luxury Tramore web design services in the Waterford region, including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'tramore-web-design'
}, {
  title: 'Belfast Web Design',
  description: 'We are an international web agency who provide luxury Belfast web design services including graphics design, search engine optimisation (SEO) and software consultancy.',
  path: 'belfast-web-design'
}, {
  title: 'Graphics Design Ireland',
  description: 'We are an international web agency who provide luxury Graphics design Ireland services including web design, search engine optimisation (SEO) and software consultancy.',
  path: 'graphics-design-ireland'
}, {
  title: 'SEO optimisation Ireland',
  description: 'We are an international web agency who provide luxury SEO optimisation Ireland services including web design, graphics design and software consultancy.',
  path: 'seo-optimisation-ireland'
}, {
  title: 'Web Design',
  description: 'We are an international web agency who provide luxury web design services including graphics design, search engine optimisation and software consultancy.',
  path: 'web-design'
}, {
  title: 'Web Consultancy Ireland',
  description: 'We are an international web agency who provide luxury web consultancy Ireland services including graphics design, search engine optimisation and software consultancy.',
  path: 'web-consultancy-ireland'
},]



// WEBPACK FOOTER //
// ./src/resources/routes.js